import React, { useContext, useEffect } from 'react';
import { useAdtopiaLoadApi } from '../Hooks/useAdtopiaLoadApi';
import { AppDomainWithoutProtocol, AppDomain, AppLpDefaultUrl, AppAdtopiaUPID, AppReferrerURL } from "../Constants/EnvConstants";
import { UUID } from "./UUID";
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../Contexts/VisitorParams";
import { useDataIngestion } from "../Hooks/useDataIngestion";
import { getQueryString } from './QueryString';
import { getBuyerName } from "../Components/Includes/Layouts/Common/BuyerBasedOnDomain";

const AdtopiaLoadLP = ({ splitName }) => {
  const history = useHistory();
  const referrer = document.referrer;
  const { getUUID, setParams } = UUID();
  const { adtopiaLoadResponse, adtopiaLoadingErr } = useAdtopiaLoadApi();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { saveDataIngestion, isLoading } = useDataIngestion();
  const urlParams = new URLSearchParams(window.location.search);
  const full_url = window.location.href;
  const query_string_arr = full_url.split("?");
  const encryptVal = urlParams.get('value');
  const field = 'uuid';
  var uuid = "";
  var queryString = getQueryString();
  const crvid = urlParams.get('crvid');
  const {brand,b_id} = getBuyerName();
  useEffect(() => {
    (async () => {
      let uuidType = 'new';
      const getUUIDParam = await getUUID('', uuidType);
      uuid = getUUIDParam;
      if (encryptVal) {
        const getdtopiaApi = await adtopiaLoadResponse(
          AppDomain + '/' + splitName + '?' + queryString,
          AppDomainWithoutProtocol,
          window.navigator.userAgent,
          uuid,
          AppAdtopiaUPID,
          AppReferrerURL
        );
        if (adtopiaLoadingErr) {          
          history.push('/' + AppLpDefaultUrl + '?uuid=' + uuid);
        }
        if (typeof getdtopiaApi !== "undefined") {
          const getdtopiaApiResponse = getdtopiaApi.data;
          if (typeof getdtopiaApiResponse.url_param === 'string' && getdtopiaApiResponse.url_param.trim() !== ''
        ) {
          const urlParamsObj = new URLSearchParams(getdtopiaApiResponse.url_param);
          const brandValue = urlParamsObj.get('b_id');
          if (!urlParamsObj.has('b_id') || !brandValue) {
            urlParamsObj.set('b_id', b_id);
          }
          getdtopiaApiResponse.url_param = urlParamsObj.toString();
        }
          if (getdtopiaApiResponse.response === 200) {
            if (getdtopiaApiResponse.domain_name === AppDomainWithoutProtocol) {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param);
              } else {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid);
              }
            } else {
              window.location.href = getdtopiaApiResponse.url + '&uuid=' + uuid;
            }
          } else if (getdtopiaApiResponse.response === 404) {
            if (getdtopiaApiResponse.url_param != "") {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + AppLpDefaultUrl + '?' + getdtopiaApiResponse.url_param);
              } else {
                history.push('/' + AppLpDefaultUrl + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid);
              }
            } else {
              history.push('/' + AppLpDefaultUrl + '?uuid=' + uuid);
            }
          }
        } else {
          history.push('/' + AppLpDefaultUrl + '?uuid=' + uuid);
        }
      } else {

        visitorParameters.data = {
          user_agent : window.navigator.userAgent,
          page_type : "LP",
          domain_name:AppDomain,
          existingdomain: window.location.href.replace(
            /(uuid=)[^&]+/,
            `$1${uuid}`
          ),
          referer_site:referrer,
          crvid:crvid ? crvid : '',
          b_id:b_id ? b_id : '',
        };
        visitorParameters.visitor_parameters = { uuid: uuid };
        (async () => {          
          queryString = queryString.replace(/(uuid=)[^&]+/, `$1${uuid}`);
          setParams(uuid, splitName);
          await saveDataIngestion(
            visitorParameters.visitor_parameters,
            {},
            'split_page_load',
            splitName,
            queryString,
            visitorParameters.data
          )
        })();
        if (queryString != null && queryString !== '') {
          if (queryString && queryString.includes('b_id=')) {
            queryString = queryString.replace(
              /(b_id=)[^&]*/,
              `$1${b_id}`
            );
          }
          if (queryString.indexOf('&' + field + '=') != -1 ||
            queryString.indexOf('?' + field + '=') != -1 ||
            queryString.indexOf(field + '=') != -1) {
            queryString = queryString.replace(/(uuid=)[^&]+/, `$1${uuid}`);
            window.history.pushState({}, '', '?' + queryString);
          } else {
            window.history.pushState({}, '', '?' + queryString + '&uuid=' + uuid);
          }
          if (
            queryString.indexOf('&b_id=') === -1 &&
            queryString.indexOf('?b_id=') === -1 &&
            queryString.indexOf('b_id=') === -1
          ) {
            window.history.pushState({}, '', '?' + queryString + '&b_id=' + b_id);
          }
        } else {
          window.history.pushState({},'',b_id && b_id.trim() !== '' ? '?uuid=' + uuid + '&b_id=' + b_id: '?uuid=' + uuid);
        }
      }
    })()
  }, [encryptVal])
  return (
    <></>
  )
}

export default AdtopiaLoadLP;